var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.largeHeader
    ? _c(
        "header",
        {
          staticClass: "d-flex align-items-center justify-content-between",
          attrs: { id: "header" },
        },
        [
          _c("ChatStats"),
          _vm._v(" "),
          _c("Search"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex header-selection-main",
              staticStyle: { "align-items": "center" },
            },
            [
              _c("TodayEvent"),
              _vm._v(" "),
              _vm.CONFIG.FEATURES.HEYSUPSIS_ENABLED
                ? _c(
                    "md-button",
                    {
                      staticClass: "custom-button header-btn btnCopilot",
                      on: { click: _vm.activateCopilot },
                    },
                    [_c("img", { attrs: { src: "/static/img/copilot.png" } })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.IsEmailEnabled()
                ? _c(
                    "md-button",
                    {
                      staticStyle: {
                        width: "fit-content",
                        cursor: "pointer",
                        display: "flex",
                      },
                      attrs: { id: "email-icon-header" },
                      on: {
                        click: function () {
                          return this$1.$router.replace("/mails?selected=My")
                        },
                      },
                    },
                    [
                      _c(
                        "md-icon",
                        { style: { color: _vm.darkMode ? "yellow" : "black" } },
                        [_vm._v("mail")]
                      ),
                      _vm._v(" "),
                      _vm.allUnreadMailCounts !== 0
                        ? _c("SupsisBadge", {
                            attrs: {
                              badge: _vm.allUnreadMailCounts,
                              "class-name": "email-unread-count",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex header-selection-main",
                  staticStyle: { "align-items": "center" },
                },
                [
                  _vm.isLiveSupportActive
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                                theme: _vm.isDarkMode
                                  ? "light-border"
                                  : "google",
                              },
                              expression:
                                "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                            },
                          ],
                          staticStyle: { "z-index": "99999999" },
                          attrs: {
                            content: _vm.$t("message.closeLiveSupport"),
                          },
                        },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                id: "close-live-support",
                                type: "danger",
                                shape: "circle",
                              },
                              on: { click: _vm.previewApp },
                            },
                            [_vm._v("X")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.newVersionAvailable
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                                theme: _vm.isDarkMode
                                  ? "light-border"
                                  : "google",
                              },
                              expression:
                                "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                            },
                          ],
                          staticClass: "custom-version-btn",
                          attrs: { content: _vm.$t("message.newVersion") },
                          on: { click: _vm.reloadPage },
                        },
                        [
                          _c("NewVersionUpdate"),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("message.newVersionShort")) +
                              "\n            "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        followCursor: true,
                        placement: "bottom-end",
                        theme: _vm.isDarkMode ? "light-border" : "google",
                      },
                      expression:
                        "{\n                followCursor: true,\n                placement: 'bottom-end',\n                theme: isDarkMode ? 'light-border' : 'google',\n            }",
                    },
                  ],
                  staticClass: "custom-button header-btn",
                  attrs: { content: _vm.$t("message.errorReport") },
                  on: { click: _vm.makeBugReport },
                },
                [
                  _c(
                    "md-icon",
                    { style: { color: _vm.darkMode ? "yellow" : "black" } },
                    [_vm._v("report")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("HeaderRight", {
                on: {
                  getSupportActivityInfo: function ($event) {
                    _vm.isLiveSupportActive = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                id: "make-bug-report",
                footer: null,
                title: _vm.$t("message.sendErrorFeedBack"),
                visible: _vm.errorModalVisible,
              },
              on: {
                cancel: function ($event) {
                  _vm.errorModalVisible = false
                },
                ok: function ($event) {
                  _vm.errorModalVisible = false
                },
              },
            },
            [
              _c("ErrorReport", {
                attrs: { "file-url": _vm.errorFileURl },
                on: {
                  changeVisibility: function ($event) {
                    _vm.errorModalVisible = false
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }